import PropTypes from 'prop-types';

import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';

import classes from './iconStyles.module.css';

const OnWarningFlagIcon = ({ onClick, customClass = '' }) => {
    return (
        <div onClick={onClick}>
            <ContactEmergencyIcon
                className={`${classes.warningFlagIcon} ${classes[customClass]}`}
            />
        </div>
    );
};

OnWarningFlagIcon.propTypes = {
    onClick: PropTypes.func,
    customClass: PropTypes.string
};

export default OnWarningFlagIcon;
